import * as contentful from 'contentful'
import type {
  ContentfulBrand,
  ContentfulCreator,
  ContentfulFeaturedPost
} from '@/services/contentful/types'

const client = contentful.createClient({
  accessToken: import.meta.env.VITE_CONTENTFUL_CDN_KEY,
  space: import.meta.env.VITE_CONTENTFUL_SPACE_ID,
  environment: 'master'
})

export async function getBrands(): Promise<ContentfulBrand[]> {
  const brands: ContentfulBrand[] = []
  const response = await client.getEntries({ 'content_type': 'featuredBusinessClient' })

  response.items.forEach((item: any) => {
    const brand: ContentfulBrand = {
      website: item.fields.website,
      logo: 'https:' + response.includes?.Asset?.find(asset => asset.sys.id == item.fields.logo.sys.id)?.fields.file.url
    }

    brands.push(brand)
  })

  return brands
}

export async function getCreators(): Promise<ContentfulCreator[]> {
  const creators: ContentfulCreator[] = []
  const response = await client.getEntries({ 'content_type': 'featuredCreatorUsers' })

  response.items.forEach((item: any) => {
    const creator: ContentfulCreator = {
      username: item.fields.Username,
      avgViews: item.fields.averageViewCount,
      followers: item.fields.followerCount,
      link: item.fields.profileLink,
      profile: 'https:' + response.includes?.Asset?.find(asset => asset.sys.id == item.fields.image.sys.id)?.fields.file.url
    }

    creators.push(creator)
  })

  return creators
}

export async function getFeaturedPosts(): Promise<ContentfulFeaturedPost[]> {
  const posts: ContentfulFeaturedPost[] = []

  const response = await client.getEntries({ 'content_type': 'featuredSocialPost' })

  response.items.forEach((item: any) => {
    const post: ContentfulFeaturedPost = {
      username: item.fields.username,
      profile: 'https:' + response.includes?.Asset?.find(asset => asset.sys.id == item.fields.profilePhoto.sys.id)?.fields.file.url,
      thumbnail: 'https:' + response.includes?.Asset?.find(asset => asset.sys.id == item.fields.thumbnail.sys.id)?.fields.file.url,
      content: 'https:' + response.includes?.Asset?.find(asset => asset.sys.id == item.fields.content.sys.id)?.fields.file.url,
    }

    posts.push(post)
  })

  return posts
}